import {Col, Form, FormControl, FormLabel, FormSelect, Row} from "react-bootstrap";
import React, {useState} from "react";
import PropTypes from "prop-types";
import {FaCheck} from "react-icons/fa";
import {CustomEditor} from "../CustomEditor";
import {ButtonBlank} from "./ButtonBlank";
import {FaEye} from "react-icons/fa";
import {FaEyeSlash} from "react-icons/fa6";


export function UsernameControl(props) {
    const {firstInputRefElement, onChange, tempObject, fieldname} = props;
    const fieldName = fieldname ? fieldname : "username";
    return <Form.Group controlId="username" className="mb-3">
        <Form.Label>Lidnummer: </Form.Label>
        <Form.Control required
                      placeholder="Lidnummer" autoComplete="username"
                      value={tempObject[fieldName]}
                      ref={firstInputRefElement}
                      onChange={event => onChange(event, fieldName)}/>
    </Form.Group>;
}

export function PasswordControl(props) {
    const {onChange ,tempObject, title, externalFieldName} = props;
    const [showPassword, setShowPassword] = useState(false);
    const fieldName = externalFieldName ? externalFieldName : "password";
    return <Form.Group controlId="password" className="mb-3">
        <Form.Label>{title ? title : "Password"} </Form.Label>

        <div style={{border: '1px solid rgba(0, 0, 0, 0.1)', borderRadius: '5px'}}>
            <Row className={'g-0'}>
                <Col>
                    <Form.Control
                        style={{border: 'none', boxShadow: 'none'}}
                        type={showPassword ? "text" : "password"}
                        required
                        placeholder="Wachtwoord" autoComplete="current-password"
                        value={tempObject[fieldName]}
                        onChange={event => onChange(event, fieldName)
                        }/>
                </Col>
                <Col xs={"auto"}>
                    <ButtonBlank onClick={() => setShowPassword(!showPassword)}
                                 style={{position: 'relative', right: '10px', top: '5px', background: 'none',}}
                                 type={"button"}>{showPassword ? <FaEyeSlash/>
                        : <FaEye/>}</ButtonBlank>
                </Col>
            </Row>


        </div>


    </Form.Group>
        ;
}

export function FormControlCustom(props) {
    const {onChange, type, filled, title, value, disabled} = props;
    return <div className={'p-1'}>
        <FormLabel>{title}<span>  <FaCheck className={filled ? '' : 'visually-hidden'}
                                           style={{position: "relative", color: 'green'}}/></span></FormLabel>
        {value ? <FormControl disabled={disabled} value={value} type={type ? type : 'text'}
                              onChange={onChange}/> : <FormControl disabled={disabled} type={type ? type : 'text'}
                                                                   onChange={onChange}/>}

    </div>
}

export function FormSelectCustom(props) {
    const {onChange, filled, title, optionArray, value} = props;
    return <div className={'p-1'}>
        <FormLabel>{title}<span>  <FaCheck className={filled ? '' : 'visually-hidden'}
                                           style={{position: "relative", color: 'green'}}/></span></FormLabel>
        {value ? <FormSelect value={value}
                             onChange={onChange}>
            {optionArray}
        </FormSelect> : <FormSelect
            onChange={onChange}>
            {optionArray}
        </FormSelect>}

    </div>
}

export function CustomEditorFilledCheck(props) {
    const {onEditorChange, filled, title, fieldName, initText} = props;

    return <div className={'p-1'}>
        <FormLabel>{title}<span>  <FaCheck className={filled ? '' : 'visually-hidden'}
                                           style={{position: "relative", color: 'green'}}/></span></FormLabel>
        <CustomEditor initText={initText ? initText : ""} fieldName={fieldName} onEditorChange={onEditorChange}/>

    </div>


}